import { gql } from '@apollo/client'

export const PRICE_CLASSES_LIST_QUERY = gql`
  query PriceClasses($showLog: Boolean) {
    priceClasses(showLog: $showLog) {
      id
      code
      name
      nameTranslatedList {
        label
        nativeLabel
        value
      }
      archivedAt
      priceActions {
        actionType
        actionAmount {
          amount
          type
          fromCurrency
          toCurrency
          direction
        }
        beneficiary {
          entityType
          entityID
          entityCode
          entityName
        }
        order
        description
        descriptionTranslatedList {
          label
          nativeLabel
          value
        }
      }
      inputCurrency
      outputCurrency
    }
  }
`

export const PRICE_CLASSES_GENERATE_MUTATION = gql`
  mutation PriceClassGenerate($input: PriceClassInput!) {
    priceClassGenerate(input: $input) {
      message
    }
  }
`

export const PRICE_CLASSES_ARCHIVE_MUTATION = gql`
  mutation PriceClassArchive($priceClassID: String!) {
    priceClassArchive(priceClassID: $priceClassID) {
      message
    }
  }
`

export const PRICE_CLASSES_DEARCHIVE_MUTATION = gql`
  mutation PriceClassDeArchive($priceClassID: String!) {
    priceClassDeArchive(priceClassID: $priceClassID) {
      message
    }
  }
`

export const PRICE_CLASSES_MODIFY_MUTATION = gql`
  mutation PriceClassModify($input: PriceClassInput!, $priceClassID: String!) {
    priceClassModify(input: $input, priceClassID: $priceClassID) {
      message
    }
  }
`
